/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import ArticlePreview from "./ArticlePreview";

export default function Blogs({ blogData, header, subHeader }) {
  const newestComesFirst = (a, b) =>
    a.fields.datePosted > b.fields.datePosted ? -1 : 1;
  return (
    <Container>
      <Header>{header}</Header>
      <SubHeader>{subHeader}</SubHeader>
      {blogData.sort(newestComesFirst).map(item => (
        <ArticlePreview key={item.sys.id} id={item.sys.id} {...item.fields} />
      ))}
    </Container>
  );
}

const Container = styled.div`
  padding: 2em;
  color: white;
  max-width: 1000px;
  margin: auto;
  @media (max-width: 600px) {
    padding: 15px;
  }
`;

const Header = styled('h1')`
  font-size: 60px;
  color: #da1b60;
  display: inline-block;
  @media (max-width: 600px) {
    font-size: 40px;
  }
`;

const SubHeader = styled.div`
  font-size: 24px;
  opacity: 0.8;
  margin-bottom: 4em;
  max-width: 600px;
  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 3em;
  }
`;
